<div class="container-fluid p-4">

    <!-- Header -->
    <div class="mb-4">
        <h2 class="text-2xl font-bold text-gray-800">Cartera Castigada (Pérdidas Incobrables)</h2>
        <p class="text-sm text-gray-500 mt-1">
            Consulta y gestión de los créditos, cuotas y clientes clasificados como pérdida incobrable.
        </p>
    </div>

    <!-- Tabs -->
    <div class="border-b border-gray-200 mb-5">
        <nav class="flex gap-6">
            <button (click)="cambiarTab('consulta')"
                    class="pb-2 text-sm font-medium border-b-2 -mb-px transition-colors"
                    [ngClass]="tab === 'consulta' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'">
                Consulta
            </button>
            <button (click)="cambiarTab('lotes')"
                    class="pb-2 text-sm font-medium border-b-2 -mb-px transition-colors"
                    [ngClass]="tab === 'lotes' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'">
                Lotes
            </button>
            <button (click)="cambiarTab('cuentas')"
                    class="pb-2 text-sm font-medium border-b-2 -mb-px transition-colors"
                    [ngClass]="tab === 'cuentas' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'">
                Cuentas contables
            </button>
        </nav>
    </div>

    <!-- ══════════════════ CONSULTA ══════════════════ -->
    <div *ngIf="tab === 'consulta'">

        <!-- Resumen -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
            <div class="bg-white border border-gray-200 rounded-lg p-4">
                <p class="text-xs uppercase tracking-wide text-gray-500">Clientes castigados</p>
                <p class="text-2xl font-bold text-gray-900 mt-1">
                    <span *ngIf="!loadingResumen">{{ resumen?.clientes?.total || 0 | number }}</span>
                    <span *ngIf="loadingResumen" class="text-gray-400"><i class="fas fa-spinner fa-spin"></i></span>
                </p>
                <p class="text-xs text-gray-500 mt-1">
                    {{ resumen?.clientes?.solo_incobrable || 0 | number }} solo incobrable ·
                    {{ resumen?.clientes?.mixtos || 0 | number }} mixtos
                </p>
            </div>
            <div class="bg-white border border-gray-200 rounded-lg p-4">
                <p class="text-xs uppercase tracking-wide text-gray-500">Créditos castigados</p>
                <p class="text-2xl font-bold text-gray-900 mt-1">
                    <span *ngIf="!loadingResumen">{{ resumen?.creditos || 0 | number }}</span>
                    <span *ngIf="loadingResumen" class="text-gray-400"><i class="fas fa-spinner fa-spin"></i></span>
                </p>
                <p class="text-xs text-gray-500 mt-1">con deuda por cobrar</p>
            </div>
            <div class="bg-white border border-gray-200 rounded-lg p-4">
                <p class="text-xs uppercase tracking-wide text-gray-500">Cuotas pendientes</p>
                <p class="text-2xl font-bold text-gray-900 mt-1">
                    <span *ngIf="!loadingResumen">{{ resumen?.cuotas || 0 | number }}</span>
                    <span *ngIf="loadingResumen" class="text-gray-400"><i class="fas fa-spinner fa-spin"></i></span>
                </p>
                <p class="text-xs text-gray-500 mt-1">de cartera castigada</p>
            </div>
            <div class="bg-white border border-gray-200 rounded-lg p-4">
                <p class="text-xs uppercase tracking-wide text-gray-500">Monto castigado</p>
                <p class="text-2xl font-bold text-gray-900 mt-1">
                    <span *ngIf="!loadingResumen">{{ resumen?.monto_por_cobrar || 0 | currency:'USD':'symbol':'1.2-2' }}</span>
                    <span *ngIf="loadingResumen" class="text-gray-400"><i class="fas fa-spinner fa-spin"></i></span>
                </p>
                <p class="text-xs text-gray-500 mt-1">cartera castigada</p>
            </div>
        </div>

        <!-- Filtros -->
        <div class="bg-white border border-gray-200 rounded-lg p-3 mb-4">
            <div class="flex flex-wrap items-end gap-3">
                <div class="flex-1 min-w-[240px]">
                    <label class="block text-xs uppercase tracking-wide font-semibold text-gray-600 mb-1">Buscar cliente</label>
                    <div class="flex gap-2">
                        <input [(ngModel)]="q" (keyup.enter)="buscar()" placeholder="Cédula o nombre…"
                               class="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400">
                        <button (click)="buscar()"
                                class="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-4 py-2 rounded whitespace-nowrap">
                            Buscar
                        </button>
                    </div>
                </div>
                <div class="min-w-[200px]">
                    <label class="block text-xs uppercase tracking-wide font-semibold text-gray-600 mb-1">Situación</label>
                    <select [(ngModel)]="estado" (change)="filtrarEstado(estado)"
                            class="w-full border border-gray-300 rounded px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-400">
                        <option value="">Todos</option>
                        <option value="SOLO">Solo incobrable</option>
                        <option value="MIXTA">Mixta</option>
                    </select>
                </div>
                <div class="min-w-[200px]">
                    <label class="block text-xs uppercase tracking-wide font-semibold text-gray-600 mb-1">Estatus del crédito</label>
                    <select [(ngModel)]="estatusCredito" (change)="filtrarEstatus(estatusCredito)"
                            class="w-full border border-gray-300 rounded px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-400">
                        <option value="">Todos</option>
                        <option value="PENDIENTE">Pago Pendiente</option>
                        <option value="PAGADO">Pagado Completado</option>
                    </select>
                </div>
                <div class="min-w-[200px]">
                    <label class="block text-xs uppercase tracking-wide font-semibold text-gray-600 mb-1">Lote</label>
                    <select [(ngModel)]="lote" (change)="filtrarLote(lote)"
                            class="w-full border border-gray-300 rounded px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-400">
                        <option value="">Todos los lotes</option>
                        <option *ngFor="let l of lotesDisponibles" [value]="l.lote">
                            {{ l.lote }} ({{ l.clientes | number }} cli. · {{ l.creditos | number }} créd.)
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <!-- Listado (compacto, scroll interno, paginación siempre visible) -->
        <div class="bg-white border border-gray-200 rounded-lg overflow-hidden">
            <div class="px-4 py-3 border-b border-gray-200 bg-gray-50 flex items-center justify-between">
                <div class="flex items-center gap-2">
                    <h3 class="text-sm font-semibold text-gray-700">Clientes</h3>
                    <span *ngIf="marcando" class="inline-flex items-center gap-1 text-xs text-blue-600">
                        <i class="fas fa-circle-notch fa-spin"></i> actualizando…
                    </span>
                </div>
                <span class="text-xs text-gray-500">{{ total | number }} en total</span>
            </div>

            <div *ngIf="loadingClientes" class="text-gray-500 text-sm py-10 text-center">
                <i class="fas fa-spinner fa-spin"></i> Cargando…
            </div>

            <div *ngIf="!loadingClientes" class="overflow-y-auto" style="max-height: 460px;">
                <table class="w-full">
                    <thead class="sticky top-0 bg-gray-50 z-10">
                        <tr class="text-left text-xs uppercase tracking-wide text-gray-500 border-b border-gray-200">
                            <th class="px-4 py-2 font-semibold">Cédula</th>
                            <th class="px-4 py-2 font-semibold">Nombre</th>
                            <th class="px-4 py-2 font-semibold">Situación</th>
                            <th class="px-4 py-2 font-semibold text-right">Créditos</th>
                            <th class="px-4 py-2 font-semibold text-right">Monto castigado</th>
                            <th class="px-4 py-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let c of clientes" (click)="verCliente(c)"
                            class="border-b border-gray-100 cursor-pointer hover:bg-blue-50/60 transition-colors">
                            <td class="px-4 py-2 text-sm text-gray-800 tabular-nums">{{ c.cedula || '—' }}</td>
                            <td class="px-4 py-2 text-sm text-gray-800">{{ c.nombre }}</td>
                            <td class="px-4 py-2">
                                <span class="text-xs px-2 py-0.5 rounded-md border font-semibold"
                                      [ngClass]="c.estado === 'MIXTA' ? 'bg-amber-50 text-amber-800 border-amber-200' : 'bg-red-50 text-red-700 border-red-200'">
                                    {{ c.label }}
                                </span>
                            </td>
                            <td class="px-4 py-2 text-sm text-gray-800 text-right tabular-nums">{{ c.creditos | number }}</td>
                            <td class="px-4 py-2 text-sm text-gray-800 text-right tabular-nums">{{ c.por_cobrar | currency:'USD':'symbol':'1.2-2' }}</td>
                            <td class="px-4 py-2 text-right">
                                <i class="fas fa-chevron-right text-xs text-gray-300"></i>
                            </td>
                        </tr>
                        <tr *ngIf="clientes.length === 0">
                            <td colspan="6" class="px-4 py-8 text-center text-sm text-gray-400">Sin resultados.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Paginación -->
            <div *ngIf="!loadingClientes" class="px-4 py-3 border-t border-gray-200 flex items-center justify-between text-sm">
                <button (click)="irPagina(page - 1)" [disabled]="page <= 1"
                        class="text-blue-600 hover:bg-blue-50 px-3 py-1 rounded disabled:text-gray-300 disabled:hover:bg-transparent">
                    Anterior
                </button>
                <span class="text-gray-500">Página {{ page }} de {{ pages || 1 }}</span>
                <button (click)="irPagina(page + 1)" [disabled]="page >= pages"
                        class="text-blue-600 hover:bg-blue-50 px-3 py-1 rounded disabled:text-gray-300 disabled:hover:bg-transparent">
                    Siguiente
                </button>
            </div>
        </div>
    </div>

    <!-- ══════════════════ LOTES ══════════════════ -->
    <div *ngIf="tab === 'lotes'">
        <div class="bg-white border border-gray-200 rounded-lg p-4 mb-4">
            <h3 class="text-sm font-semibold text-gray-700 mb-1">Cortes de castigo (lotes)</h3>
            <p class="text-xs text-gray-500 mb-4">
                Simular muestra, sin marcar nada, qué créditos y clientes entrarían en un nuevo lote con la fecha de corte
                indicada (solo los que aún no fueron marcados en un lote anterior). Crear lote ejecuta el marcaje real.
            </p>

            <div class="flex flex-wrap items-end gap-3">
                <div>
                    <label class="block text-xs uppercase tracking-wide font-semibold text-gray-600 mb-1">Fecha de corte</label>
                    <input type="date" [(ngModel)]="corte"
                           class="border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400">
                </div>
                <button (click)="simular()" [disabled]="simulando || marcando"
                        class="border border-gray-300 text-gray-700 hover:bg-gray-50 text-sm font-semibold px-4 py-2 rounded disabled:opacity-50">
                    <i *ngIf="simulando" class="fas fa-spinner fa-spin mr-1"></i> Simular
                </button>
                <button (click)="crearLote()" [disabled]="marcando || simulando"
                        class="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-4 py-2 rounded disabled:opacity-50">
                    <i *ngIf="marcando" class="fas fa-spinner fa-spin mr-1"></i> Crear lote
                </button>
                <button *ngIf="simulacion" (click)="descargarExcel()" [disabled]="descargando"
                        class="ml-auto border border-green-600 text-green-700 hover:bg-green-50 text-sm font-semibold px-4 py-2 rounded disabled:opacity-50">
                    <i class="fas mr-1" [ngClass]="descargando ? 'fa-spinner fa-spin' : 'fa-file-excel'"></i> Descargar Excel
                </button>
            </div>

            <div *ngIf="generandoMsg" class="mt-4 border border-amber-200 bg-amber-50 rounded-md p-4 flex items-center gap-3">
                <i class="fas fa-spinner fa-spin text-amber-600"></i>
                <p class="text-sm text-amber-800">{{ generandoMsg }}</p>
            </div>

            <!-- Progreso en tiempo real del marcaje -->
            <div *ngIf="marcando" class="mt-4 border border-blue-200 bg-blue-50 rounded-md p-4">
                <div class="flex items-center justify-between mb-2">
                    <div class="flex items-center gap-2 min-w-0">
                        <i class="fas fa-spinner fa-spin text-blue-600"></i>
                        <p class="text-sm font-semibold text-blue-800 truncate">
                            {{ marcandoMsg || 'Marcando lote…' }}
                            <span *ngIf="loteEnCurso" class="font-normal text-blue-600">· Lote {{ loteEnCurso }}</span>
                        </p>
                    </div>
                    <span class="text-sm font-bold text-blue-800 tabular-nums whitespace-nowrap ml-3">{{ lotePorcentaje | number:'1.0-0' }}%</span>
                </div>

                <!-- Barra -->
                <div class="w-full h-2.5 rounded-full bg-blue-100 overflow-hidden">
                    <div class="h-full rounded-full bg-blue-600 transition-all duration-500 ease-out"
                         [style.width.%]="lotePorcentaje"></div>
                </div>

                <!-- Fase y contadores -->
                <div class="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-blue-700">
                    <span class="font-semibold text-blue-800">Fase: {{ faseLabel }}</span>
                    <span class="tabular-nums">
                        créditos {{ loteCreditosMarcados | number }} / {{ loteTotalCreditos | number }}
                    </span>
                    <span class="tabular-nums">
                        clientes {{ loteClientesMarcados | number }} / {{ loteTotalClientes | number }}
                    </span>
                </div>

                <p class="text-xs text-blue-700 mt-2">El marcaje real se ejecuta en el servidor. Podés seguir trabajando o recargar la página; te avisamos al terminar.</p>
            </div>

            <div *ngIf="simulacion" class="mt-4 border border-blue-100 bg-blue-50 rounded-md p-4">
                <p class="text-sm text-gray-700">
                    Con corte <b>{{ corte }}</b> entrarían
                    <b>{{ simulacion.creditos | number }}</b> créditos nuevos,
                    de <b>{{ simulacion.clientes | number }}</b> clientes.
                </p>
                <p class="text-xs text-gray-500 mt-1">Simulación: no se marcó nada.</p>
            </div>
        </div>

        <!-- Resultado de la simulación (mismo estilo que Consulta) -->
        <div *ngIf="simulacion" class="bg-white border border-gray-200 rounded-lg overflow-hidden">
            <div class="px-4 py-3 border-b border-gray-200 bg-gray-50 flex flex-wrap items-center justify-between gap-3">
                <h3 class="text-sm font-semibold text-gray-700">Clientes que entrarían</h3>
                <div class="flex items-center gap-2">
                    <input [(ngModel)]="simQ" (keyup.enter)="buscarSim()" placeholder="Cédula o nombre…"
                           class="border border-gray-300 rounded px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400">
                    <button (click)="buscarSim()"
                            class="bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold px-3 py-1.5 rounded">
                        Buscar
                    </button>
                    <span class="text-xs text-gray-500 ml-1">{{ simTotal | number }} en total</span>
                </div>
            </div>

            <div *ngIf="loadingSim" class="text-gray-500 text-sm py-10 text-center">
                <i class="fas fa-spinner fa-spin"></i> Cargando…
            </div>

            <div *ngIf="!loadingSim" class="overflow-y-auto" style="max-height: 420px;">
                <table class="w-full">
                    <thead class="sticky top-0 bg-gray-50 z-10">
                        <tr class="text-left text-xs uppercase tracking-wide text-gray-500 border-b border-gray-200">
                            <th class="px-4 py-2 font-semibold">Cédula</th>
                            <th class="px-4 py-2 font-semibold">Nombre</th>
                            <th class="px-4 py-2 font-semibold text-right">Créditos</th>
                            <th class="px-4 py-2 font-semibold text-right">Por cobrar</th>
                            <th class="px-4 py-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let s of simItems" (click)="verClienteSim(s)"
                            class="border-b border-gray-100 cursor-pointer hover:bg-blue-50/60 transition-colors">
                            <td class="px-4 py-2 text-sm text-gray-800 tabular-nums">{{ s.cedula || '—' }}</td>
                            <td class="px-4 py-2 text-sm text-gray-800">{{ s.nombre }}</td>
                            <td class="px-4 py-2 text-sm text-gray-800 text-right tabular-nums">{{ s.creditos | number }}</td>
                            <td class="px-4 py-2 text-sm text-gray-800 text-right tabular-nums">{{ s.por_cobrar | currency:'USD':'symbol':'1.2-2' }}</td>
                            <td class="px-4 py-2 text-right"><i class="fas fa-chevron-right text-xs text-gray-300"></i></td>
                        </tr>
                        <tr *ngIf="simItems.length === 0">
                            <td colspan="5" class="px-4 py-8 text-center text-sm text-gray-400">Sin resultados.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div *ngIf="!loadingSim" class="px-4 py-3 border-t border-gray-200 flex items-center justify-between text-sm">
                <button (click)="irPaginaSim(simPage - 1)" [disabled]="simPage <= 1"
                        class="text-blue-600 hover:bg-blue-50 px-3 py-1 rounded disabled:text-gray-300 disabled:hover:bg-transparent">
                    Anterior
                </button>
                <span class="text-gray-500">Página {{ simPage }} de {{ simPages || 1 }}</span>
                <button (click)="irPaginaSim(simPage + 1)" [disabled]="simPage >= simPages"
                        class="text-blue-600 hover:bg-blue-50 px-3 py-1 rounded disabled:text-gray-300 disabled:hover:bg-transparent">
                    Siguiente
                </button>
            </div>
        </div>
    </div>

    <!-- ══════════════════ CUENTAS CONTABLES ══════════════════ -->
    <div *ngIf="tab === 'cuentas'">
        <div class="bg-white border border-gray-200 rounded-lg overflow-hidden">
            <div class="px-4 py-3 border-b border-gray-200 bg-gray-50 flex items-center justify-between">
                <h3 class="text-sm font-semibold text-gray-700">Cuentas contables de pérdidas</h3>
                <button (click)="crearCuenta()"
                        class="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-4 py-2 rounded">
                    <i class="fas fa-plus mr-1"></i> Crear cuenta
                </button>
            </div>

            <div *ngIf="loadingCuentas" class="text-gray-500 text-sm py-10 text-center">
                <i class="fas fa-spinner fa-spin"></i> Cargando…
            </div>

            <table *ngIf="!loadingCuentas" class="w-full">
                <thead>
                    <tr class="text-left text-xs uppercase tracking-wide text-gray-500 border-b border-gray-200">
                        <th class="px-4 py-2 font-semibold">Banco</th>
                        <th class="px-4 py-2 font-semibold">Método asociado</th>
                        <th class="px-4 py-2 font-semibold">Símbolo</th>
                        <th class="px-4 py-2 font-semibold">Número</th>
                        <th class="px-4 py-2 font-semibold">Desde</th>
                        <th class="px-4 py-2 font-semibold">Estado</th>
                        <th class="px-4 py-2 font-semibold text-right">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let c of cuentas" class="border-b border-gray-100 text-sm text-gray-800 hover:bg-gray-50">
                        <td class="px-4 py-2">{{ c.banco || '—' }}</td>
                        <td class="px-4 py-2">
                            <span *ngIf="c.metodo" class="text-xs px-2 py-0.5 rounded-md border font-semibold bg-blue-50 text-blue-700 border-blue-200">{{ c.metodo }}</span>
                            <span *ngIf="!c.metodo" class="text-xs text-gray-400 italic">Sin asociar</span>
                        </td>
                        <td class="px-4 py-2">{{ c.simbolo || '—' }}</td>
                        <td class="px-4 py-2 tabular-nums">{{ c.numero || '—' }}</td>
                        <td class="px-4 py-2">{{ c.desde ? (c.desde | date:'dd/MM/yyyy') : '—' }}</td>
                        <td class="px-4 py-2">
                            <span class="text-xs px-2 py-0.5 rounded-md border font-semibold"
                                  [ngClass]="c.activa ? 'bg-green-50 text-green-700 border-green-200' : 'bg-gray-100 text-gray-500 border-gray-200'">
                                {{ c.activa ? 'Activa' : 'Inactiva' }}
                            </span>
                        </td>
                        <td class="px-4 py-2 text-right whitespace-nowrap">
                            <button (click)="asociarCuenta(c)"
                                    class="text-blue-600 hover:bg-blue-50 text-xs font-semibold px-2 py-1 rounded">
                                Asociar
                            </button>
                            <button (click)="toggleCuenta(c)"
                                    class="text-xs font-semibold px-2 py-1 rounded ml-1"
                                    [ngClass]="c.activa ? 'text-gray-600 hover:bg-gray-100' : 'text-green-600 hover:bg-green-50'">
                                {{ c.activa ? 'Inactivar' : 'Activar' }}
                            </button>
                        </td>
                    </tr>
                    <tr *ngIf="cuentas.length === 0">
                        <td colspan="7" class="px-4 py-8 text-center text-sm text-gray-400">No hay cuentas registradas.</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</div>

<!-- ══════════════════ DRAWER: detalle del cliente (NgbOffcanvas, position end) ══════════════════ -->
<ng-template #detalleDrawer let-offcanvas>
    <div class="offcanvas-header border-b border-gray-200">
        <div class="w-full flex items-start justify-between">
            <div>
                <h5 class="text-base font-bold text-gray-900 mb-0">Detalle del cliente</h5>
                <p class="text-xs text-gray-500 mt-0.5">Créditos y cuotas de cartera castigada</p>
            </div>
            <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('cross')"></button>
        </div>
    </div>

    <div class="offcanvas-body">
        <div *ngIf="loadingDetalle" class="text-gray-500 text-sm py-10 text-center">
            <i class="fas fa-spinner fa-spin"></i> Cargando…
        </div>

        <div *ngIf="!loadingDetalle && detalle">
            <!-- Encabezado del cliente -->
            <div class="mb-4">
                <p class="text-lg font-bold text-gray-900">{{ detalle.cliente?.nombre }}</p>
                <p class="text-sm text-gray-500 mt-0.5 tabular-nums">{{ detalle.cliente?.cedula }}</p>
                <div class="flex flex-wrap gap-2 mt-3 items-center">
                    <span class="text-xs px-2 py-0.5 rounded-md border font-semibold"
                          [ngClass]="detalle.cliente?.estado === 'MIXTA' ? 'bg-amber-50 text-amber-800 border-amber-200' : 'bg-red-50 text-red-700 border-red-200'">
                        {{ detalle.cliente?.label }}
                    </span>
                    <span *ngIf="(detalle.cliente?.lotes || []).length" class="text-xs border border-gray-200 rounded px-2 py-0.5 text-gray-600">
                        Lotes:
                        <b class="text-gray-800" *ngFor="let l of detalle.cliente?.lotes; let i = index">{{ i ? ', ' : '' }}{{ l.lote }}</b>
                    </span>
                </div>
            </div>

            <!-- Acción principal -->
            <button (click)="verComprasFinanciadas()"
                    class="w-full bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-4 py-2.5 rounded mb-5">
                <i class="fas fa-shopping-cart mr-1"></i> Ver Compras financiadas
            </button>

            <!-- Créditos -->
            <p class="text-xs uppercase tracking-wide text-gray-500 mb-2 font-semibold">Créditos</p>
            <div *ngFor="let cr of detalle.creditos" class="border border-gray-200 rounded-md mb-3">
                <div class="flex items-center justify-between px-3 py-2 bg-gray-50 border-b border-gray-100">
                    <span class="text-sm font-semibold text-gray-800">{{ cr.identifier }}</span>
                    <span class="text-xs text-gray-500">Creado {{ cr.creado | date:'dd/MM/yyyy' }} · Lote {{ cr.lote }}</span>
                </div>
                <table class="w-full">
                    <thead>
                        <tr class="text-left text-xs text-gray-500 border-b border-gray-100">
                            <th class="px-3 py-1 font-medium">Cuota</th>
                            <th class="px-3 py-1 font-medium">Vence</th>
                            <th class="px-3 py-1 font-medium text-right">Saldo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let q of cr.cuotas" class="text-sm text-gray-700 border-b border-gray-50">
                            <td class="px-3 py-1">{{ q.order }}</td>
                            <td class="px-3 py-1">{{ q.vence | date:'dd/MM/yyyy' }}</td>
                            <td class="px-3 py-1 text-right tabular-nums">{{ q.saldo | currency:'USD':'symbol':'1.2-2' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</ng-template>
